import React from "react";
import { Portal } from "./config/case-manager";
import "./app.css"
function App() {
  return (
    <>{Portal()}</>
  );
}

export default App;
